var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgErrorPreventiveMaintenance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 77,
    viewBox: "0 0 77 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.907227,
    y: 0.964844,
    width: 76,
    height: 76,
    rx: 38,
    fill: "#9D1816"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5277 55.9648L35.3057 38.0241L35.1885 41.9523L22.0553 24.6564H30.2049L39.4098 36.9687H36.3024L45.566 24.6564H53.481L40.2306 41.9523L40.2893 38.0241L54.0087 55.9648H45.7419L36.0679 42.8904L39.1167 43.3008L29.6186 55.9648H21.5277Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorPreventiveMaintenance);
export default __webpack_public_path__ + "static/media/errorPreventiveMaintenance.f4bf03a5d4aa7a6888c8b96530e7fe67.svg";
export { ForwardRef as ReactComponent };